import fr from 'facet-rest';
import YesNoQuestion from 'Components/UI/YesNoQuestion';
import YesNoQuestionWithHelperText from 'Components/UI/YesNoQuestionWithHelperText';

const AccountApplicationStepOverrideBase = fr
  .metaOverride()
  .nameOverride([
    'stepName',
    'stepOrdinal',
    'completed',
    'isCustodial',
    'primaryApplicantName',
    'secondaryApplicantName',
    'relationship',
  ], { hidden: true })
  .overrideAll({
    _customHelperProps: {
      showRequiredHelperText: true,
      showOptionalHelperText: true,
    },
  })
  .nameOverride([
    'hasBeneficiary',
    'hasInterestedParty',
    'subjectToBackUpWithholding',
  ], {
    _component: () => YesNoQuestion,
  })
  .nameOverride([
    'primaryApplicantIsFinraAffiliated',
    'secondaryApplicantIsFinraAffiliated',
  ], {
    _component: () => YesNoQuestionWithHelperText,
    _customProps: {
      helperText: 'If so, you’ll need a 3210 letter which authorizes you to to keep your account at Facet.',
    },
  })
  .nameOverride([
    'primaryApplicantIsPoliticallyExposed',
    'secondaryApplicantIsPoliticallyExposed',
  ], {
    _component: () => YesNoQuestionWithHelperText,
    _customProps: {
      helperText: 'A politically exposed person is one who has been entrusted with a prominent public function. Examples of a politically exposed person could be government officials, high ranking judges, or high ranking member of the military.',
    },
  })
  .nameOverride([
    'primaryApplicantIsControlPerson',
    'secondaryApplicantIsControlPerson',
  ], {
    _component: () => YesNoQuestionWithHelperText,
    _customProps: {
      helperText: 'Are you a director, officer, or stockholder of 10% or more in this company?',
    },
  })
  .nameOverride([
    'hasTrustedContact',
  ], {
    _component: () => YesNoQuestionWithHelperText,
    _customProps: {
      helperText: 'A person you authorize Facet to contact in limited circumstances, such as if there is a concern about activity in your account and we are unable to get in touch with you.',
    },
  })
  .nameOverride(
    [
      'primaryApplicantBirthCountry',
      'primaryApplicantVisaType',
      'primaryApplicantVisaExpirationDate',
      'secondaryApplicantBirthCountry',
      'secondaryApplicantVisaType',
      'secondaryApplicantVisaExpirationDate',
      'trustedContactFirstName',
      'trustedContactLastName',
      'trustedContactAddressLine1',
      'trustedContactCity',
      'trustedContactState',
      'trustedContactZipCode',
      'trustedContactCountry',
      'trustedContactPhoneNumber',
      'trustedContactPhoneNumberType',
      'trustedContactEmail',
      // Employment Info,
      'interestedPartyCompanyName',
      'interestedPartyAddressLine1',
      'interestedPartyAddressLine2',
      'interestedPartyCity',
      'interestedPartyState',
      'interestedPartyZipCode',
      'interestedPartyCountry',
      'secondaryApplicantEmployer',
      'secondaryApplicantPositionEmployed',
      'secondaryApplicantIsFinraAffiliated',
      'secondaryApplicantFinraFirmName',
      'secondaryApplicantAttachments',
      'secondaryApplicantIsControlPerson',
      'secondaryApplicantCompanySymbols',
      'secondaryApplicantIsPoliticallyExposed',
      'secondaryApplicantPoliticalOrganization',
      'secondaryApplicantImmediateFamilyPoliticallyExposed',
      'primaryApplicantEmployer',
      'primaryApplicantPositionEmployed',
      'primaryApplicantFinraFirmName',
      'primaryApplicantCompanySymbols',
      'primaryApplicantPoliticalOrganization',
      'primaryApplicantImmediateFamilyPoliticallyExposed',

    ],
    {
      _customHelperProps: {
        showOptionalHelperText: false,
      },
    },
  );

export const AccountApplicationStepOverride = fr
  .metaOverride({ base: AccountApplicationStepOverrideBase })
  .nameOverride(['firstName'], { required: true })
// overriding prompt here because our parsing of meta in the backend doesn't allow for commas
  .nameOverride(['isOrganization'], { prompt: 'Is this an organization, trust, or charity?' })
  .done();

export const AccountApplicationStepOverrideRelationshipOther = fr
  .metaOverride({ base: AccountApplicationStepOverride })
  .nameOverride(['relationship'], { hidden: false, required: true })
  .done();

export const AccountApplicationStepOverrideOrganization = fr
  .metaOverride({ base: AccountApplicationStepOverrideBase })
  .nameOverride(['firstName'], { hidden: true, required: false })
  .nameOverride(['lastName'], { prompt: 'Organization/Trust/Charity' })
  .nameOverride(['socialSecurityNumber'], { prompt: 'Tax ID' })
  .nameOverride(['birthDate'], { hidden: true, required: false })
  .done();

export const AccountApplicationStepOverrideOrganizationRelationshipOther = fr
  .metaOverride({ base: AccountApplicationStepOverrideOrganization })
  .nameOverride(['relationship'], { hidden: false, required: true })
  .done();
